import { LayoutDashboard, Boxes, FolderKanban, BookOpen, Scale, Map, Search, Sparkles, Users, Activity, Radar, Newspaper, Flag, FileText, MessageSquare, Bell } from "lucide-react";

// Nav model. `phase: 0` items are live now; `phase: 1` render as scaffolded
// placeholders until their module lands (foundations-first, no shortcuts).
export const OS_NAV = [
  { key: "dashboard", label: "Executive Dashboard", icon: LayoutDashboard, path: "/os", phase: 0 },
  { key: "ask", label: "Ask ArcaOS", icon: MessageSquare, path: "/os/ask", phase: 0 },
  { key: "attention", label: "AI Attention", icon: Radar, path: "/os/attention", phase: 0 },
  { key: "brief", label: "Daily Brief", icon: Newspaper, path: "/os/brief", phase: 0 },
  { key: "catalog", label: "Product Catalog", icon: Boxes, path: "/os/catalog", phase: 0 },
  { key: "projects", label: "Projects", icon: FolderKanban, path: "/os/projects", phase: 0 },
  { key: "bible", label: "Project Bible", icon: BookOpen, path: "/os/bible", phase: 0 },
  { key: "business-brief", label: "Business Brief", icon: FileText, path: "/os/business-brief", phase: 0 },
  { key: "decisions", label: "Decision Log", icon: Scale, path: "/os/decisions", phase: 0 },
  { key: "roadmap", label: "Roadmap", icon: Map, path: "/os/roadmap", phase: 0 },
  { key: "milestones", label: "Milestones", icon: Flag, path: "/os/milestones", phase: 0 },
  { key: "search", label: "Search", icon: Search, path: "/os/search", phase: 1 },
  { key: "prompts", label: "Prompt Library", icon: Sparkles, path: "/os/prompts", phase: 0 },
  { key: "notifications", label: "Notifications", icon: Bell, path: "/os/notifications", phase: 0 },
  { key: "members", label: "Members", icon: Users, path: "/os/members", phase: 0 },
  { key: "activity", label: "Activity", icon: Activity, path: "/os/activity", phase: 0 },
];

// Maps an ArcaOS entity_type to the nav key whose badge should reflect it.
export const ENTITY_TO_NAV = {
  product: "catalog",
  project: "projects",
  bible: "bible",
  business_brief: "business-brief",
  decision: "decisions",
  roadmap_item: "roadmap",
  milestone: "milestones",
  prompt: "prompts",
};
